import o from "styled-components";
const n = o.div``, t = o(n)`
  display: flex;
  flex-direction: column;
`, e = o(n)`
  margin-top: ${(p) => p.$mode === "Basic" ? "24px" : "0px"};
  margin-bottom: 9px;
`, i = o(n)`
  margin: 16px 0 8px;
`;
export {
  e as AddressContainer,
  n as BaseWrapper,
  i as InputContainer,
  t as Wrapper
};
